<div class="modal-content">
    <div class="modal-header border-0">
        <h5 class="modal-title" id="modulesModalLabel">Asignar trasladista</h5>
        <button type="button" class="btn-close" (click)="modal.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <form novalidate [formGroup]="transferDriverForm">
            <div class="mb-3">
                <label class="col-12 form-label m-0" for="employee_id">Trasladista <span class="txt-danger"> *</span></label>
                <select class="col-12 form-select" id="employee_id" required formControlName="employee_id"
                        [ngClass]="{ 'is-invalid' : (employee?.touched || validate) && employee?.errors, 'is-valid' : !employee?.errors}">
                    <option [ngValue]="null" disabled selected>Trasladista</option>
                    <option *ngFor="let employee of employeesLis" [value]="employee.id">{{ employee.name }}</option>
                </select>
                @if (employee?.errors) {
                    <div class="invalid-feedback">Selecciona un trasladista</div>
                }
            </div>
        </form>
    </div>
    <div class="modal-footer border-0 pt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismissAll()">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="assigntransferdriver()">Asignar trasladista</button>
    </div>
</div>
